import { useRef } from "react"
import { arrayOf } from "prop-types"
import { contributorPropType } from "./contributorPropType"
import { DynamicDataView } from "components/ui"
import Icon from "components/planning_center_icon"
import { pluralize } from "utils/helpers"
import { ContributorsModal } from "./ContributorsModal"
import { ModalContextProvider, ModalTrigger, useModal } from "../modals/Modal"
import { contributorPermissionLookup } from "./contributorPermissionLookup"

const ContributorsTable = ({ contributors }) => {
  const { onModalClose, onModalOpen } = useModal()
  const modalRef = useRef(null)

  const handleRowClick = (row, _col) => {
    modalRef.current?.initializePerson(row)
    onModalOpen()
  }

  const handleModalClose = () => {
    onModalClose()
  }

  const handleModalSave = person => {
    // TODO: Handle saving the contributor here
    person
    handleModalClose()
  }

  const renderAvatar = (row, _col) => (
    <img src={row.avatar_url} alt={`${row.name} avatar`} className="contributors__avatar" />
  )

  const columns = [
    {
      cell: "avatar_url",
      render: renderAvatar,
      className: "contributors__avatar-cell"
    },
    {
      cell: "name",
      label: "Name",
      isSortable: true
    },
    {
      cell: "permission_level",
      label: "Contributor permissions",
      render: row => contributorPermissionLookup[row.permission_level],
      isSortable: true
    },
    {
      cell: "actions",
      render: () => <Icon symbol="general#pencil" className="contributors__edit-icon" />,
      className: "contributors__edit-icon-row"
    }
  ]

  const renderPrimaryField = item => {
    return (
      <div className="d-f ai-c g-2">
        {renderAvatar(item)}
        <div>
          <div className="fw-b">{item.name}</div>
          <div className="card__secondary">
            {contributorPermissionLookup[item.permission_level]}
          </div>
        </div>
        <div className="contributors__edit-icon--mobile">
          <Icon symbol="general#pencil" />
        </div>
      </div>
    )
  }

  return (
    <>
      <ContributorsModal ref={modalRef} onSave={handleModalSave} onCancel={onModalClose} />
      <DynamicDataView
        heading={{
          useCounter: true,
          headerText: pluralize("contributor", "contributors", contributors.length),
          style: { padding: "12px" }
        }}
        headingChildren={
          <ModalTrigger title="Add contributor" theme="primary" modal={ContributorsModal} />
        }
        columns={columns}
        rows={contributors}
        emptyTableMessage="There are no contributors for this signup yet."
        emptyTableImageUrl="/static/blank-states/no-filtered-results.svg"
        primaryField={renderPrimaryField}
        onRowClick={handleRowClick}
      />
    </>
  )
}

ContributorsTable.propTypes = {
  contributors: arrayOf(contributorPropType).isRequired
}

const ContributorsTableWrapper = props => (
  <ModalContextProvider>
    <ContributorsTable {...props} />
  </ModalContextProvider>
)

export default ContributorsTableWrapper
